import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Waves_ds_get_shipments_by_waveIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { waveId: number }): 
  Promise<{ result: { Id?: number, ActualWarehouseId?: number, CarrierId?: number, CarrierServiceTypeId?: number, Cartonized?: boolean, CreatedSysDateTime?: string, CreatedSysUser?: string, DateNeeded?: string, ExpectedWarehouseId?: number, LookupCode?: string, WaveId?: number, Tasks?: { Id?: number, OperationCodeId?: number, PickSlipId?: number, StatusId?: number, HardAllocations?: { Id?: number, Details?: { Id?: number }[] }[] }[], OrderLookups?: { OrderId?: number, ShipmentId?: number, Order?: { Id?: number, LookupCode?: string, OrderStatusId?: number, OwnerReference?: string, VendorReference?: string, Status?: { Name?: string } } }[], Carrier?: { Id?: number, Name?: string, ShortName?: string }, CarrierServiceType?: { Id?: number, Name?: string, ShortName?: string }, ActualWarehouse?: { Id?: number, Name?: string }, ExpectedWarehouse?: { Id?: number, Name?: string }, Wave?: { Id?: number, StatusId?: number, Status?: { Name?: string } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.waveId)) {
      missingRequiredInParams.push('\'waveId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Waves/datasources/ds_get_shipments_by_waveId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { waveId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualWarehouseId?: number, CarrierId?: number, CarrierServiceTypeId?: number, Cartonized?: boolean, CreatedSysDateTime?: string, CreatedSysUser?: string, DateNeeded?: string, ExpectedWarehouseId?: number, LookupCode?: string, WaveId?: number, Tasks?: { Id?: number, OperationCodeId?: number, PickSlipId?: number, StatusId?: number, HardAllocations?: { Id?: number, Details?: { Id?: number }[] }[] }[], OrderLookups?: { OrderId?: number, ShipmentId?: number, Order?: { Id?: number, LookupCode?: string, OrderStatusId?: number, OwnerReference?: string, VendorReference?: string, Status?: { Name?: string } } }[], Carrier?: { Id?: number, Name?: string, ShortName?: string }, CarrierServiceType?: { Id?: number, Name?: string, ShortName?: string }, ActualWarehouse?: { Id?: number, Name?: string }, ExpectedWarehouse?: { Id?: number, Name?: string }, Wave?: { Id?: number, StatusId?: number, Status?: { Name?: string } } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.waveId)) {
      missingRequiredInParams.push('\'waveId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Waves/datasources/ds_get_shipments_by_waveId/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { waveId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualWarehouseId?: number, CarrierId?: number, CarrierServiceTypeId?: number, Cartonized?: boolean, CreatedSysDateTime?: string, CreatedSysUser?: string, DateNeeded?: string, ExpectedWarehouseId?: number, LookupCode?: string, WaveId?: number, Tasks?: { Id?: number, OperationCodeId?: number, PickSlipId?: number, StatusId?: number, HardAllocations?: { Id?: number, Details?: { Id?: number }[] }[] }[], OrderLookups?: { OrderId?: number, ShipmentId?: number, Order?: { Id?: number, LookupCode?: string, OrderStatusId?: number, OwnerReference?: string, VendorReference?: string, Status?: { Name?: string } } }[], Carrier?: { Id?: number, Name?: string, ShortName?: string }, CarrierServiceType?: { Id?: number, Name?: string, ShortName?: string }, ActualWarehouse?: { Id?: number, Name?: string }, ExpectedWarehouse?: { Id?: number, Name?: string }, Wave?: { Id?: number, StatusId?: number, Status?: { Name?: string } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.waveId)) {
      missingRequiredInParams.push('\'waveId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Waves/datasources/ds_get_shipments_by_waveId/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      waveId: number    }) {
        if(isNil(inParams.waveId)) {
          return true; 
        }
      return false;
    }
}
